import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { Message } from 'element-ui'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue'), meta: { title: '登入' } },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { title: '首頁' }
  },
  {
    path: '/workbench',
    name: 'Workbench',
    component: () => import('../views/Workbench.vue'),
    meta: { title: '圖片工作台 · 圖生圖' }
  },
  {
    path: '/workbench/competitor',
    name: 'WorkbenchCompetitor',
    component: () => import('../views/Workbench.vue'),
    meta: { title: '圖片工作台 · 競品參考' }
  },
  {
    path: '/video',
    name: 'VideoWorkbench',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · 圖生影片' }
  },
  {
    path: '/video/remake',
    name: 'VideoRemake',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · 影片復刻' }
  },
  {
    path: '/agent',
    name: 'Agent',
    component: () => import('../views/Agent.vue'),
    meta: { title: 'Agent' }
  },
  {
    path: '/jobs',
    name: 'JobCenter',
    component: () => import('../views/JobCenter.vue'),
    meta: { title: '任務中心', requiresAuth: true }
  },
  {
    path: '/materials',
    name: 'MaterialLib',
    component: () => import('../views/MaterialLib.vue'),
    meta: { title: '素材庫' }
  },
  // 「範本管理」已移到**管理端**（管理端侧边栏「提示詞範本」）：
  // 提示词是平台级配置，用户改了会影响所有人的出图，不该开放给用户端。
  // 客户端入口与弹窗均已移除；老链接重定向到首页，避免 404。
  {
    path: '/prompts',
    redirect: '/home'
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/Recharge.vue'),
    meta: { title: '儲值', requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { title: '個人中心', requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 需要开通才可进入的模块：key 与后端 CustomerKit.MODULE_KEYS 一致
const ROUTE_MODULE = {
  '/workbench': 'image',
  '/workbench/competitor': 'competitor',
  '/video': 'video',
  '/video/remake': 'video_remake',
  '/materials': 'materials'
}

// 全局守卫：全站可自由浏览，只有标注 meta.requiresAuth 的页面才要求登录（弹窗、不跳转）
// 未登录时 modules 为 null，hasModule 放行，所以工作台/素材库都能进去看
router.beforeEach((to, from, next) => {
  const logged = store.getters.isLoggedIn
  if (to.path === '/login') {
    next() // 登录页可访问
    return
  }
  // 需要登录的页面：不再跳转登录页，改为原地弹登录框（登录后回到原页）
  if (to.meta && to.meta.requiresAuth && !logged) {
    store.dispatch('openLogin', to.fullPath)
    if (from ? from.name : null) {
      next(false) // 站内点击：留在原页，只弹登录框
    } else {
      next('/home') // 直接输网址进来：先落到首页
    }
    return
  }
  // 菜单保留、点击给提示：未开通的模块不放行
  const need = ROUTE_MODULE[to.path]
  if (need) {
    if (!store.getters.hasModule(need)) {
      const label = to.meta ? to.meta.title : ''
      Message.warning('「' + (label ? label : '該模組') + '」未開通，請聯絡管理員開通後再使用')
      if (from ? from.name : null) {
        next(false) // 站内点击：留在原页
      } else {
        next('/home') // 直接输网址进来：落到首页（首页不依赖任何单个模块）
      }
      return
    }
  }
  next()
})

router.afterEach(to => {
  document.title = (to.meta && to.meta.title ? to.meta.title + ' - ' : '') + '創視魔方'
})

export default router
